import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useAuth } from '../../auth/auth-gate';
import { useGameHeader } from '../../components/layout';
import { HowToPlayPage } from '../../features/how-to-play/how-to-play-page';
import { brandAssets } from '../../brand-assets';

const HowToPlayRouteComponent = () => {
  const navigate = useNavigate();
  const { markHowToPlaySeen } = useAuth();

  useGameHeader({
    center: brandAssets ? (
      <img src={brandAssets.logo} alt="Spin To Win" className="h-10 object-contain" />
    ) : null,
  });

  return (
    <HowToPlayPage
      onComplete={() => {
        markHowToPlaySeen();
        void navigate({ to: '/lobby' });
      }}
    />
  );
};

export const Route = createFileRoute('/_authenticated/how-to-play')({
  component: HowToPlayRouteComponent,
});
